<template>
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ xycase.Name }}</p>
    </div>
    <div class="bottom_content">
      <div v-if="xycase.Cases != null">
        <div
          v-for="d in xycase.Cases"
          :key="d.CaseId"
          class="list_item"
          @click="openUrl(caseHost + '#/case/detail/' + d.CaseId)"
        >
          <ul>
            <li>
              <div class="list_top">
                <div class="list_left">
                  <h3 class="tit_l">{{ d.Title }}</h3>
                  <p>{{ d.NickName }}</p>
                </div>
                <div v-if="d.Avatar != ''" class="list_right">
                  <img alt="" :src="api.FileHost + d.Avatar" />
                </div>
                <div v-else class="list_right">
                  <img alt="" src="@/assets/images/logo.png" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <OpenIframe ref="OpenIframe" />
  </div>
</template>

<script>
  import { ref, onActivated, onDeactivated, onMounted } from 'vue'
  import OpenIframe from '@/components/OpenIframe'
  import router from '@/router'
  import store from '@/store'
  import api from '@/api'
  export default {
    components: {
      OpenIframe,
    },
    props: {
      // eslint-disable-next-line vue/require-default-prop
      xycase: {
        type: Object,
      },
    },
    data() {
      return {
        api,
        caseHost: null,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      async init() {
        this.caseHost = await store.getters['system/getCaseUrl']
      },
      goUrl(url) {
        window.location.href = url
      },
      openUrl(url) {
        this.$refs['OpenIframe'].show(url)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .bottom_content {
    padding-top: 15px;
  }
  .list_item {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e8e8e9;
    box-shadow: 0px 0px 5px 0px rgba(232, 232, 233, 0.88);
    border-radius: 9px;
    margin: 0 0 15px 0;
    ul {
      li {
        .list_top {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 0 15px;
          .list_left {
            width: 80%;
            padding: 10px 0;
            h3 {
              padding: 0;
              margin: 0;
              margin-bottom: 8px;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #888;
            }
            .tit_l {
              width: 260px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            p {
              padding: 0;
              margin: 0;
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #4f515f;
            }
          }
          .list_right {
            width: 40px;
            height: 40px;
            border-radius: 4px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .list_bottom {
          padding: 5px 15px;
          border-top: 1px solid #e8e8e9;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding-top: 5px;
          p {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #b57e48;
          }
        }
      }
    }
  }
</style>
